import axios from 'axios';
import { ADMIN_URL } from 'shared/app-settings';

const getAuthHeader = () => {
    // Token được lưu sẵn dưới dạng 'Bearer eyJ...' trong localStorage
    const token = localStorage.getItem('giam_thi_token') || '';
    // Nếu chưa có prefix Bearer, tự thêm vào
    const authValue = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
    return { Authorization: authValue };
};

const giamSatThiService = {
    /** Đăng nhập cho giám thị — xác thực user + kiểm tra phân công ca thi */
    login(body: { email: string; password: string; caThiCode: string }) {
        return axios.post(ADMIN_URL + 'giamsatthi/loginGiamThi', body);
    },

    /** Lấy danh sách ca thi */
    getListCaThi() {
        return axios.get(ADMIN_URL + `giamsatthi/listCaThi`, {
            headers: getAuthHeader(),
        });
    },

    /** Lấy danh sách phòng thi của ca thi */
    getPhongThi(caThiId: number) {
        return axios.get(ADMIN_URL + `giamsatthi/phongThi`, {
            headers: getAuthHeader(),
            params: { caThiId },
        });
    },

    /** Tổng quan ca thi */
    getOverview(caThiId: number) {
        return axios.get(ADMIN_URL + `giamsatthi/overview`, {
            headers: getAuthHeader(),
            params: { caThiId },
        });
    },

    /** Danh sách thí sinh + tiến độ real-time (có thể filter theo phòng thi) */
    getListStudents(caThiId: number, phongThiId?: number) {
        const params: any = { caThiId };
        if (phongThiId) {
            params.phongThiId = phongThiId;
        }
        return axios.get(ADMIN_URL + `giamsatthi/listStudents`, {
            headers: getAuthHeader(),
            params,
        });
    },

    /** Tiến độ từng kỹ năng của 1 thí sinh (đọc Redis) */
    getStudentSkills(caThiId: number, userId: number) {
        return axios.get(ADMIN_URL + `giamsatthi/studentSkills`, {
            headers: getAuthHeader(),
            params: { caThiId, userId },
        });
    },

    /** Log hành vi thí sinh */
    getStudentDetail(caThiId: number, userId: number) {
        return axios.get(ADMIN_URL + `giamsatthi/studentDetail`, {
            headers: getAuthHeader(),
            params: { caThiId, userId },
        });
    },

    /** Hành động giám thị: lock, resume, report */
    action(body: { caThiId: number; userId: number; action: string; reason?: string }) {
        return axios.post(ADMIN_URL + `giamsatthi/action`, body, {
            headers: getAuthHeader(),
        });
    },
};

export { giamSatThiService };
